import produce from "immer";

import { LOCATION_UPDATE } from "../actions/types";

const initialState = {
  pathname: "",
  params: {}
};

export default (state = initialState, action) => {
  return produce(state, draft => {
    // eslint-disable-next-line
    switch (action.type) {
      case LOCATION_UPDATE:
        draft.pathname = action.payload.pathname;
        draft.params = action.payload.params;
        break;
    }
  });
};
